"use strict";
const closePointEps = 1e-4;
const curveEps = 1e-4;

export { closePointEps, curveEps };
//# sourceMappingURL=const.mjs.map
